<div class="main-container d-flex">
    <div class="ndg-container m-2 p-2">
        <mat-form-field class="w-100">
            <input type="text" placeholder="{{ 'survey.search-ndg' | translate }}" aria-label="Number" matInput [formControl]="ndgFormControl" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayNdg.bind(this)" (optionSelected)="onNdgSelection($event.option.value)">
                <mat-option *ngFor="let ndg of filteredOptions | async" [value]="ndg">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-auto" style="color:#535353;">
                                <fa-icon *ngIf="ndg.typology === 'FIS'" [icon]="['fas', 'user']" size="2x"></fa-icon>
                                <fa-icon *ngIf="ndg.typology === 'GIU'" [icon]="['fas', 'user-tie']" size="2x"></fa-icon>
                            </div>
                            <div class="col">
                                <div class="row">
                                    <div class="col fw-bold">{{ ndg.fullName }}</div>
                                </div>
                                <div class="row">
                                    <div class="col text-muted"><small>{{ ndg.ndg }}</small></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <div *ngIf="selectedNdg">
            <div class="text-center clickable" [routerLink]="['/survey/' + selectedNdg.ndg]">
                <div style="color:grey" class="mb-2">
                    <fa-icon *ngIf="selectedNdg.typology === 'FIS'" [icon]="['fas', 'user']" size="4x"></fa-icon>
                    <fa-icon *ngIf="selectedNdg.typology === 'GIU'" [icon]="['fas', 'user-tie']" size="4x"></fa-icon>
                </div>
                <div class="fw-bold">{{ selectedNdg.fullName }}</div>
                <div class="fw-light">
                    <small class="text-uppercase">{{ selectedNdg.ndg }}</small>
                </div>
            </div>

            <div class="survey-list card mt-2">
				<div class="card-header text-center text-uppercase">
					<span>{{ 'survey.title' | translate }}</span> 
					<span class="badge rounded-pill bg-secondary ms-2">{{ surveyList.length }}</span>
                </div>
                
				<div class="list-group list-group-flush">
					<div class="survey-new list-group-item list-group-item-success clickable" *ngIf="hasInsertPermission()" [routerLink]="['new']">
						<span>{{ 'survey.new-label' | translate }}</span>
                        <fa-icon [icon]="['fas', 'plus-circle']" class="float-end"></fa-icon>
                    </div>

                    <div class="survey-element clickable py-2 ps-2 pe-4" *ngFor="let survey of surveyList" [routerLink]="[survey.surveyId]" [ngClass]="{selected: isSurveySelected(survey.surveyId)}">
                        <span class="float-end right-arrow">
                            <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
                        </span>

                        <div class="row align-items-center">
                            <div class="col-auto" [ngClass]="{ 'draft': survey.draft, 'not-draft': !survey.draft }">
                                <fa-layers>
                                    <fa-icon [icon]="['fas', 'file-lines']" size="2x"></fa-icon>
                                    <fa-layers-text *ngIf="survey.draft" content="TEST" class="fw-bold draft-text" transform="rotate--45 right-5"></fa-layers-text>
                                </fa-layers>
                            </div>
                            <div class="col">
                                <div class="row">
                                    <div class="col fw-bold"><small>{{ 'survey.id' | translate }}: {{ survey.surveyId }}</small></div>
                                </div>
                                <div class="row">
                                    <div class="col text-muted"><small>{{ 'survey.created-at' | translate }}: {{ survey.insertTime }}</small></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="survey-container">
        <router-outlet></router-outlet>
    </div>
</div>
